import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/track`;

export const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const body = JSON.stringify({ path: pathname, referrer: document.referrer });
    if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "text/plain" }));
    else fetch(ENDPOINT, { method: "POST", body, keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(() => {});
  }, [pathname]);
  return null;
};
